import { render, staticRenderFns } from "./CouponPay.vue?vue&type=template&id=2688c1d8&scoped=true&"
import script from "./CouponPay.vue?vue&type=script&lang=js&"
export * from "./CouponPay.vue?vue&type=script&lang=js&"
import style0 from "./CouponPay.vue?vue&type=style&index=0&id=2688c1d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2688c1d8",
  null
  
)

export default component.exports